import type { MarkerOutput } from "../markerAuthoringDraft";
import { Button, Inline, TextInput } from "../../ui";
import type { LabelDraft } from "./labelInspectorDraft";

export function AnswerControl({
  draft,
  output,
  suggestionId,
  suggestions,
  onChange,
}: {
  draft: LabelDraft;
  output: MarkerOutput;
  suggestionId: string;
  suggestions: string[];
  onChange: (patch: Partial<LabelDraft>) => void;
}) {
  if (output === "boolean") {
    return (
      <Inline>
        <Button
          aria-pressed={draft.value === true}
          type="button"
          variant="secondary"
          onClick={() => {
            onChange({ value: true });
          }}
        >
          True
        </Button>
        <Button
          aria-pressed={draft.value === false}
          type="button"
          variant="secondary"
          onClick={() => {
            onChange({ value: false });
          }}
        >
          False
        </Button>
      </Inline>
    );
  }
  return (
    <>
      <TextInput
        description={
          suggestions.length > 0
            ? `Assertion values: ${suggestions.join(", ")}`
            : undefined
        }
        label={output === "number" ? "Number" : "Category"}
        list={output === "category" ? suggestionId : undefined}
        type={output === "number" ? "number" : "text"}
        value={typeof draft.value === "string" ? draft.value : ""}
        onChange={(event) => {
          onChange({ value: event.currentTarget.value });
        }}
      />
      {output === "category" ? (
        <datalist id={suggestionId}>
          {suggestions.map((suggestion) => (
            <option key={suggestion} value={suggestion} />
          ))}
        </datalist>
      ) : null}
    </>
  );
}
